/**
 * @type {HttpOptions}
 */
let httpOptions = {
    mode: 'same-origin',
    cache: 'default',
    credentials: 'same-origin',
    redirect: 'follow',
    referrer: 'client',
};

/**
 * @type {ClientOptions}
 */
let clientOptions = {
    basePath: '/zapi/',
};

/**
 * @returns {Readonly<HttpOptions>}
 */
export const getHttpOptions = () => httpOptions;

/**
 * @returns {Readonly<ClientOptions>}
 */
export const getClientOptions = () => clientOptions;

/**
 * @param {Partial<HttpOptions>} nextHttpOptions
 * @returns {Readonly<HttpOptions>}
 */
export const applyHttpOptions = (nextHttpOptions) => {
    httpOptions = {
        ...httpOptions,
        ...nextHttpOptions,
    };

    return httpOptions;
};

/**
 * @param {Partial<ClientOptions>} nextClientOptions
 * @returns {Readonly<ClientOptions>}
 */
export const applyClientOptions = (nextClientOptions) => {
    clientOptions = {
        ...clientOptions,
        ...nextClientOptions,
    };

    return clientOptions;
};

/**
 * @typedef {Object} ClientOptions
 * @prop {string} basePath
 * @prop {$ZAPI.Stage} [stage]
 * @typedef
    {
        Pick<
            RequestInit,
            | 'mode'
            | 'cache'
            | 'credentials'
            | 'redirect'
            | 'referrer'
        >
    } HttpOptions
 */
